import { ValueConfig } from "@app/views/private/admin/model/advertisers";
import { PageControl } from "./page-control";

export class OemDealer {
  id: string;
  name: string;
}

export class SearchDealer {
  addDealers?: boolean;
  cpfCnpj?: number | string;
  groupId?: string;
  dealersIds?: string[];
  oemDealerId?: string;
  pageControl?: PageControl;
  searchQuery?: string;
  phoneNumber?: string;
}

export class ExclusiveGroup {
  createdAt?: Date;
  dealerIds?: string[];
  id?: string;
  name?: string;
  numDealers?: number;
  numPendingDealers?: number;
  oemDealerId?: string;
  showEdit?: boolean;
  expandList?: boolean;
  dealers?: any[];
  segmentCashbackConfig: Map<string, ValueConfig>;
  segmentComissionConfig: Map<string, ValueConfig>;
  sellingTerms: string;
}

export enum OemDealerType {
  DEALERSHIP = 'Concessionária',
  CAR_RENTAL = 'Locadora',
  BANK = 'Financeira',
  RESELLER = 'Revenda'
}

export enum OemDealerPlatform {
  AUTO_ARREMATE = 'AUTO_ARREMATE',
  MOOTUX = 'MOOTUX'
}

export class OemDealerPlatformLabel {
  static allPlatforms = [
    { value: OemDealerPlatform.AUTO_ARREMATE, label: 'Auto Arremate' },
    { value: OemDealerPlatform.MOOTUX, label: 'Mootux' },
  ];
}

export class Banner { 
  id: string;
  name: string;
  personalizationId?:string;
  disabled: boolean;
  imageDesktop: string;
  imageMobile: string;
  oemDealerId?: string;
  urlDestination: string;
  createdAt: Date
  target: string;
  scheduleType?: 'ABSOLUTE_DATE' | 'CRON_RECURRENCE';
  startDate?: Date;
  endDate?: Date;
  activationCron?: string;
  deactivationCron?: string;
  status?: string;
  nextScheduledActivation?: Date;
  dealerFilterUrl?: string;
  dealerFilter?: any;

  constructor(){
    this.target = "ALL";
    this.scheduleType = undefined;
  }
}

export enum PlateInfoProvider {
  TECNOL = 'TECNOL',
  INFOCAR = 'INFOCAR',
  AUTOCREDCAR = 'AUTOCREDCAR',
  TECNOL_V2 = 'TECNOL_V2'
}

export const PlateInfoProviderLabel: Record<PlateInfoProvider, string> = {
  [PlateInfoProvider.TECNOL]: 'TecnolAPI',
  [PlateInfoProvider.INFOCAR]: 'InfoCarAPI',
  [PlateInfoProvider.AUTOCREDCAR]: 'AutoCredCarAPI',
  [PlateInfoProvider.TECNOL_V2]: 'TecnolV2API'
}

export type PlateInfoCapability = 'BASIC_INFO' | 'MOLICAR_PRICING' | 'ORIGINAL_EQUIPMENT' | 'RENAVAM_AND_OWNER';

export const PlateInfoProviderCoverage: Record<PlateInfoProvider, PlateInfoCapability[]> = {
  [PlateInfoProvider.TECNOL]: ['BASIC_INFO', 'RENAVAM_AND_OWNER'],
  [PlateInfoProvider.INFOCAR]: ['BASIC_INFO', 'MOLICAR_PRICING', 'ORIGINAL_EQUIPMENT', 'RENAVAM_AND_OWNER'],
  [PlateInfoProvider.AUTOCREDCAR]: ['BASIC_INFO'],
  [PlateInfoProvider.TECNOL_V2]: ['BASIC_INFO', 'RENAVAM_AND_OWNER']
}

export interface PlateInfoProviderConfig {
  fallbackEnabled: boolean;
  preferredProvider: PlateInfoProvider | null;
  customFallbackOrder: PlateInfoProvider[] | null;
}